import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../api/dbService';
import { slidingSessionConfig } from '../api/config';

export default function Login({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authService.login(email, password);
      if (!res.success || !res.token) throw new Error('Giriş başarısız');

      const storageData = {
        id: res.user.id,
        musteri_ID: res.user.musteri_ID,
        name: res.user.name,
        email: res.user.email,
        username: res.user.username,
        role: res.user.role,
        tel: res.user.tel,
        firma: res.user.firma,
        adres: res.user.adres
      };

      localStorage.setItem(slidingSessionConfig.tokenKey, res.token);
      localStorage.setItem(slidingSessionConfig.userKey, JSON.stringify(storageData));
      localStorage.setItem('user', JSON.stringify({ user: storageData, token: res.token }));

      window.dispatchEvent(new CustomEvent('auth-state-changed'));
      setIsAuthenticated(true);
      setTimeout(() => navigate('/', { replace: true }), 100);
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) setError('E-posta adresi veya parola hatalı!');
      else if (status === 500) setError('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
      else setError(err.message || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      {/* floating orbs */}
      <div style={{
        position: 'absolute', width: 320, height: 320, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(14,165,233,.15), transparent 70%)',
        top: '10%', left: '5%', pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute', width: 240, height: 240, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(16,185,129,.12), transparent 70%)',
        bottom: '15%', right: '8%', pointerEvents: 'none'
      }} />

      <div className="login-card" style={{ animation: 'fade-up .4s ease both' }}>
        <div className="text-center mb-4">
          <div className="login-brand mb-1">TermoTrack</div>
          <p className="text-muted mb-0" style={{ fontSize: '.85rem' }}>
            Soğuk Zincir Takip Sistemi
          </p>
        </div>

        {error && (
          <div
            className="d-flex align-items-center gap-2 mb-3 p-3 rounded-3"
            style={{ background: 'rgba(239,68,68,.08)', border: '1px solid rgba(239,68,68,.25)', color: '#b91c1c', fontSize: '.85rem' }}
          >
            <i className="fas fa-exclamation-circle flex-shrink-0"></i>
            <span>{error}</span>
            <button className="btn-close ms-auto" style={{ fontSize: '.7rem' }} onClick={() => setError('')} />
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">E-posta</label>
            <div className="input-group">
              <span className="input-group-text" style={{ border: '1.5px solid rgba(14,165,233,.2)', borderRight: 'none', background: 'rgba(14,165,233,.04)' }}>
                <i className="fas fa-envelope text-muted" style={{ fontSize: '.8rem' }}></i>
              </span>
              <input
                type="email"
                className="form-control"
                style={{ borderLeft: 'none' }}
                placeholder="ornek@firma.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Parola</label>
            <div className="input-group">
              <span className="input-group-text" style={{ border: '1.5px solid rgba(14,165,233,.2)', borderRight: 'none', background: 'rgba(14,165,233,.04)' }}>
                <i className="fas fa-lock text-muted" style={{ fontSize: '.8rem' }}></i>
              </span>
              <input
                type={showPass ? 'text' : 'password'}
                className="form-control"
                style={{ borderLeft: 'none', borderRight: 'none' }}
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="btn"
                style={{ border: '1.5px solid rgba(14,165,233,.2)', borderLeft: 'none', background: 'rgba(14,165,233,.04)' }}
                onClick={() => setShowPass(p => !p)}
              >
                <i className={`fas ${showPass ? 'fa-eye-slash' : 'fa-eye'} text-muted`} style={{ fontSize: '.8rem' }}></i>
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-brand w-100 py-2" disabled={loading}>
            {loading ? (
              <><span className="spinner-border spinner-border-sm me-2" />Giriş yapılıyor...</>
            ) : (
              <><i className="fas fa-arrow-right-to-bracket me-2"></i>Giriş Yap</>
            )}
          </button>
        </form>

        <div className="text-center mt-3">
          <small className="text-muted">
            Hesabınız yok mu?{' '}
            <Link to="/register" style={{ color: 'var(--teal)', fontWeight: 600 }}>Kayıt Ol</Link>
          </small>
        </div>

        <div className="text-center mt-4 pt-3" style={{ borderTop: '1px solid rgba(14,165,233,.1)' }}>
          <small style={{ color: '#94a3b8', fontSize: '.75rem' }}>
            © {new Date().getFullYear()} Inkatech Ölçüm Sistemleri
          </small>
        </div>
      </div>
    </div>
  );
}
